export type FaqItem = {
  question: string
  answer: string[]
}

export const faqItems: FaqItem[] = [
  {
    question: '¿Sirve para diabetes tipo 1 y tipo 2?',
    answer: [
      'Sí. El Tomo 1 explica las diferencias entre ambos tipos y el sistema de sustituciones está diseñado para adaptarse a las necesidades de cada uno.',
      'El Kit Control Total incluye además una guía de ajuste específica por tipo de diabetes.',
    ],
  },
  {
    question: '¿Los ingredientes se consiguen en Argentina?',
    answer: [
      'Sí — ese fue el criterio principal al desarrollar cada receta. Todos los ingredientes están disponibles en supermercados argentinos comunes.',
      'Sin productos importados. Sin marcas específicas. Sin complicaciones.',
    ],
  },
  {
    question: '¿Reemplaza la consulta con el médico o el nutricionista?',
    answer: [
      'No. El MegaPack es un sistema práctico de cocina adaptada: no reemplaza el seguimiento médico profesional.',
      'Sí te da herramientas para complementarlo: registros, tablas y guías que podés compartir con tu equipo de salud en cada consulta.',
    ],
  },
  {
    question: '¿Cómo recibo el material?',
    answer: [
      '100% digital. PDF listo para descargar e imprimir.',
      'Acceso inmediato después del pago: en menos de 5 minutos estás adentro.',
    ],
  },
  {
    question: '¿Funciona si soy familiar de alguien con diabetes y soy yo quien cocina?',
    answer: [
      'Exactamente para eso también está diseñado. El Tomo 1 te da el contexto que necesitás para entender qué cocinar y por qué, aunque vos no tengas diabetes.',
      'Miles de personas que compran el MegaPack son familiares que cocinan para alguien que sí la tiene.',
    ],
  },
  {
    question: '¿Tiene garantía real?',
    answer: [
      '7 días completos. Si no es lo que esperabas, te devolvemos el 100% del dinero.',
      'Sin formularios. Sin demoras. Sin drama.',
    ],
  },
]
